<!-- eslint-disable vue/html-self-closing -->
<template>
  <div>
    <h3>Sign-Up Links</h3>
    <hr />
    <div v-if="loading" class="alert alert-info">
      <p>Loading current sign-up link for domain</p>
    </div>
    <div v-else-if="currentLinks.length > 0">
      <h4>Current Link{{ currentLinks.length > 1 ? 's' : '' }}</h4>
      <SignupLinkCurrent
        v-for="currentLink in currentLinks"
        :current-link="currentLink"
        :key="currentLink['signup_token']"
        :link-status="linkStatus(currentLink)"
        :domain-uuid="domainUuid"
        :loading="loading"
        :timezone-abbrev="timezoneAbbrev"
        :timezone-message="timezoneMessage"
        @updatedLink="updateCurrentLinks"
      />
    </div>
    <div v-else class="alert alert-info">
      <p>No active sign-up link exists for this domain.</p>
    </div>
    <hr />
    <SignupLinkNew
      v-if="!loading"
      :uses-external-id="usesExternalId"
      :domain-uuid="domainUuid"
      :timezone-message="timezoneMessage"
      :toolkit-max-users="toolkitMaxUsers"
      @updatedLink="handleUpdatedLink"
    />
    <div v-if="currentLinks.length > 0" class="alert alert-info">
      Caution: Generating a new link will expire the current link.
    </div>
    <hr />
    <SignupLinksPast
      :past-links="pastLinks"
      :timezone-abbrev="timezoneAbbrev"
      :timezone-message="timezoneMessage"
    />
  </div>
</template>

<script>
import SignupLinkCurrent from './SignupLinkCurrent.vue'
import SignupLinkNew from './SignupLinkNew.vue'
import SignupLinksPast from './SignupLinksPast.vue'
import { localDateTimeStringFromUTCdateTimeString, dateInputValueFromDateObj } from './helpers'
export default {
  name: 'SignupLinks',
  components: {
    SignupLinkCurrent,
    SignupLinkNew,
    SignupLinksPast
  },
  props: {
    domainUuid: {
      type: String,
      required: true
    },
    usesExternalId: {
      type: Boolean,
      default: false
    },
    toolkitMaxUsers: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      currentLinks: [],
      pastLinks: []
    }
  },
  methods: {
    formatLink({
      domain_uuid,
      signup_token,
      created_by,
      updated_by,
      notes,
      total_capacity,
      used_capacity,
      remaining_capacity,
      activation_date,
      expiration_date,
      license_end_date,
      updated_at
    }) {
      const formattedLink = {
        domainUuid: domain_uuid,
        signupToken: signup_token,
        createdBy: created_by,
        updatedBy: updated_by,
        notes,
        // capacity fields
        totalCapacity: total_capacity,
        usedCapacity: used_capacity,
        remainingCapacity: remaining_capacity,
        // time fields
        activationDateString: localDateTimeStringFromUTCdateTimeString(activation_date),
        expirationDateString: localDateTimeStringFromUTCdateTimeString(expiration_date),
        licenseEndDateString: dateInputValueFromDateObj(new Date(license_end_date)),
        updatedAt: localDateTimeStringFromUTCdateTimeString(updated_at)
      }
      this.loading = false
      return formattedLink
    },
    updateCurrentLinks(updatedLink) {
      var foundIndex = this.currentLinks.findIndex(
        x => x['signup_token'] == updatedLink['signup_token']
      )
      this.currentLinks[foundIndex] = this.formatLink(updatedLink)
    },
    addNewLink(newLink) {
      this.currentLinks.unshift(this.formatLink(newLink))
    },
    fetchLinks() {
      this.loading = true
      this.$angularWorld.adminApi.getAllDomainSignupLinks(this.domainUuid).then(signupLinks => {
        this.loading = false
        if (signupLinks.length > 0) {
          const currentLinks = []
          const pastLinks = []
          signupLinks.forEach(link => {
            const expired =
              new Date() >
              new Date(localDateTimeStringFromUTCdateTimeString(link['expiration_date']))
            if (expired) {
              pastLinks.push(link)
            } else {
              currentLinks.push(this.formatLink(link))
            }
          })
          this.pastLinks = pastLinks
          this.currentLinks = currentLinks
        }
      })
    },
    linkStatus(currentLink) {
      if (!currentLink) {
        return ''
      }
      const pending = new Date() < new Date(currentLink.activationDateString)
      const expired = new Date() > new Date(currentLink.expirationDateString)
      if (pending) {
        return 'Pending'
      }
      if (expired) {
        return 'Expired'
      }
      return 'Active'
    },
    handleUpdatedLink(newLink) {
      this.addNewLink(newLink)
      this.fetchLinks()
    }
  },
  computed: {
    timezoneMessage() {
      const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone
      return `*Times reflect your current timezone: ${timezoneName}`
    },
    timezoneAbbrev() {
      return new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]
    }
  },
  mounted() {
    this.fetchLinks()
  }
}
</script>
